import React from 'react';

const Main = ({ children, ...other }) => {
  // Adding overflow hidden to main helps the header to stick to the top on mobile devices
  return (
    <main {...other}>
      {children}
    </main>
  )
}

export default Main
